import { Paper, Stack, Typography } from '@mui/material'
import { IContractSchema } from '../../../definitions/ContractSchema'

interface P {
    schema: IContractSchema
}

const JsonPreviewView = ({ schema }: P) => {
    return (
        <Stack sx={{ height: '100%', p: 2 }}>
            <Typography variant='subtitle1'>
                Contract Schema Preview
            </Typography>

            <Paper
                sx={{
                    mt: 2,
                    flex: 1,
                    overflow: 'auto'
                }}>
                <pre style={{ margin: 0 }}>
                    {JSON.stringify(schema, null, 2)}
                </pre>
            </Paper>
        </Stack>
    )
}

export default JsonPreviewView
